import { Link, Navigate } from "react-router-dom";
import { obtenerGruposPermitidos } from "../../config/navegacion";
import "./centroNavegacion.css";

export default function CentroNavegacion({ grupoId }) {
  const grupo = obtenerGruposPermitidos().find((item) => item.id === grupoId);

  if (!grupo) return <Navigate to="/home" replace />;

  return (
    <main className="centro-navegacion">
      <Link className="centro-navegacion-volver" to="/home">
        <i className="pi pi-arrow-left" aria-hidden="true" /> Volver al inicio
      </Link>
      <header className="centro-navegacion-cabecera">
        <span className="centro-navegacion-icono"><i className={`pi ${grupo.icono}`} aria-hidden="true" /></span>
        <div>
          <small>Menú de opciones</small>
          <h1>{grupo.titulo}</h1>
          <p>{grupo.descripcion}</p>
        </div>
      </header>
      {grupoId === "consultas" && <Link className="centro-navegacion-instructivo" to="/tutorial/reportes" target="_blank" rel="noopener noreferrer" aria-label="Abrir instructivo de Reportes en una pestaña nueva">
        <span className="centro-navegacion-instructivo-icono"><i className="pi pi-book" aria-hidden="true" /></span>
        <span><strong>Instructivo de Reportes</strong><small>Conocé las categorías, filtros y opciones de exportación.</small></span>
        <i className="pi pi-arrow-up-right" aria-hidden="true" />
      </Link>}
      <section className="centro-navegacion-opciones" aria-label={`Opciones de ${grupo.titulo}`}>
        {grupo.opciones.map((opcion) => (
          <Link key={opcion.ruta} to={opcion.ruta}>
            <i className={`pi ${opcion.icono}`} aria-hidden="true" />
            <span><strong>{opcion.label}</strong><small>{opcion.descripcion}</small></span>
            <i className="pi pi-chevron-right" aria-hidden="true" />
          </Link>
        ))}
      </section>
    </main>
  );
}
